<script setup lang="ts">
import OsaiIntegration from './components/OsaiIntegration.vue'
</script>

<template>
  <main>
    <Suspense>
      <template #default>
        <OsaiIntegration></OsaiIntegration>
      </template>
      <template #fallback>
        <h1>Seven Osai table tennis client loading</h1>
      </template>
    </Suspense>
  </main>
</template>

<style scoped lang="scss">
main {
  display: flex;
}
</style>
